module.exports = __webpack_public_path__ + "static/media/lending-tools2.98139314.svg";